module.exports = __webpack_public_path__ + "static/media/sc7.6206c9cf.jpg";